export default {
	insertIsSelectedKey(arr) {
		// insert isSelect key in every object
		arr.map(obj => {
			obj.isSelected = false;
			Object.keys(obj).map(key => {
				if (Array.isArray(obj[key])) {
					this.insertIsSelectedKey(obj[key]);
				}
			});
		});
		return arr;
	},
	compressImage(blob, quality) {
		return new Promise((resolve, reject) => {
			const img = new Image();
			const reader = new FileReader();

			reader.onload = (event) => {
				img.src = event.target.result;
			};

			img.onload = () => {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				canvas.width = img.width;
				canvas.height = img.height;
				ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
				canvas.toDataURL('image/jpeg', quality, (dataUrl) => {
					resolve(dataUrl);
				});
			};

			img.onerror = (error) => {
				reject(error);
			};

			reader.onerror = (error) => {
				reject(error);
			};

			reader.readAsDataURL(blob);
		});
	}
};
